import classNames from "classnames";
import { ReactNode } from "react";

import Spinner from "~/components/shared/Spinner";
import Icon from "~/components/shared/Icon";

import Option from "~/components/shared/Chooser/option";

interface SelectOptionProps {
  value: string;
  label: string;
  description: ReactNode;
  saving?: boolean;
  selected?: boolean;
}

interface SelectIconProps {
  saving: boolean;
  selected: boolean;
}

function SelectOption(props: SelectOptionProps) {
  return (
    <Option
      value={props.value}
      className={classNames("btn hover-bg-silver block", {
        "bg-silver": props.selected,
      })}
    >
      <div className="items-top flex">
        <div className="flex-none">
          <SelectIcon saving={props.saving ?? false} selected={props.selected ?? false} />
        </div>
        <div>
          <span className="semi-bold block">{props.label}</span>
          <small className="dark-gray font-normal">{props.description}</small>
        </div>
      </div>
    </Option>
  );
}

SelectOption.displayName = "Chooser.SelectOption";

function SelectIcon(props: SelectIconProps) {
  const size = 25;

  if (props.saving) {
    return (
      <div className="relative inline-block" style={{ width: size, height: size }}>
        <Spinner className="absolute max-w-full" size={16} color={false} style={{ left: 3 }} />
      </div>
    );
  }

  const tickColor = props.selected ? "green" : "dark-gray";

  return (
    <Icon
      icon="permission-small-tick"
      className={classNames(tickColor, "relative")}
      style={{ width: size, height: size, top: -3, left: -2 }}
    />
  );
}

export default SelectOption;
